import * as d3 from "d3";
import {
    addGridlines,
    colonAnnotation,
    DEFAULT_AXIS_FONT_SIZE,
    DEFAULT_AXIS_LABEL_FONT_SIZE,
    fw_progressive_1way,
    numberFormat,
    responsivefy
} from '../functions'

export default function (chart, divId, vizName,resData, filterParam, checkbox, gridflag) {
    const defaultSize = true
    const defaultChartLayout = {
        width: 1000,
        height: 400,
        margin: { top: 30, right: 150, bottom: 100, left: 100 }
    }
    const chartWidth = defaultSize ? defaultChartLayout.width : chart.width
    const chartHeight = defaultSize ? defaultChartLayout.height : chart.height
    const chartMargin = defaultSize ? defaultChartLayout.margin : chart.margin

    var size = defaultSize ? DEFAULT_AXIS_FONT_SIZE : chart.axisFontSize
    var fontSize = size + "px"
    var fontColor = chart.axisFontColor
    var axisLabelFontSize = (defaultSize ? DEFAULT_AXIS_LABEL_FONT_SIZE : chart.axisLabelFontSize) + "px"
    //var tempVar = chart.tempVar
    // var url = '/api/fetchDataWithParam/' + chart.data.datasqlId + '/' + vizName

    console.log("Chart vizName called:", vizName)

    // axios.post(url, filterParam).then(response => {
        let data = resData

        data.forEach(function (d) {
            d.dim1_name = new Date(d.dim1_name);
            d.metric1 = +d.metric1;
        });

        var dataXAxis = d3.nest()
            .key(d => {
                return d.dim1_name;
            })
            .key(d => {
                return d.dim2_name;
            })
            .rollup(v => {
                return d3.sum(v, d => {
                    return d.metric1;
                });
            })
            .entries(data);

        dataXAxis.forEach(y => {
            y.dim1_name = y.key;
            y.values.forEach(d => {
                d.dim2_name = d.key;
                d.metric1 = +d.value;
            });
            y.values.sort((a, b) => {
                return b.metric1 - a.metric1
            });
        });

        var mainCategoryList = dataXAxis[0].values.map(d => {
            return d.dim2_name;
        });

        // Set the x and y values
        var x1Scale = d3.scaleTime().range([0, chartWidth]);
        var y1Scale = d3.scaleLinear().range([chartHeight, 0]);

        var formatTime = d3.timeFormat("%Y-%m-%d");

        // Define the axes
        var x1AxisLabel = d3.axisBottom(x1Scale).tickFormat(formatTime);

        var y1AxisLabel = d3.axisLeft(y1Scale).ticks(10).tickFormat(numberFormat);

        //Define the line
        var dataline = d3.line()
            .x(function (d) {
                return x1Scale(d.dim1_name);
            })
            .y(function (d) {
                return y1Scale(d.metric1);
            });

        var svg = d3.select(divId).select("svg").remove();
        // Adds the canvas
        svg = d3.select(divId)
            .append("svg")
            .attr("width", chartWidth + chartMargin.left + chartMargin.right)
            .attr("height", chartHeight + 3 * chartMargin.top + chartMargin.bottom)
            .call(responsivefy)
            .attr("font", "Arial")
            .style("font-size", fontSize)
            .append("g")
            .attr("transform", "translate(" + chartMargin.left + "," + chartMargin.top + ")");

        // Add <defs> and <clipPath> to the SVG
    svg.append("defs")
        .append("svg:clipPath")
        .attr("id", "clip")  // Use d.key for the clipPath id
        .append("svg:rect")
        .attr("x", 0)
        .attr("y", -10)
        .attr("width", chartWidth)   // Clip width matches chart width
        .attr("height", chartHeight+10); // Clip height matches chart height

        // Append a group with clipPath applied
        const contentGroup = svg.append("g")
            .attr("class", "content")
            .attr("clip-path", "url(#clip)");

        if (gridflag === true) {
            addGridlines(svg, x1Scale, y1Scale, chart);
        }
        // Nest the entries by symbol
        var dNest = d3.nest().key(function (d) {
            return d.dim2_name;
        }).entries(data);

        // set the colour scale
        var metric1ColorScale = d3.scaleOrdinal(fw_progressive_1way);
        metric1ColorScale.domain(mainCategoryList);

        // Scale the range of the data
        x1Scale.domain(d3.extent(data, (d) => {
            return d.dim1_name;
        }));
        y1Scale.domain([(function() {
            var minVal = d3.min(data, function(d) {
                return d.metric1;
            });
            return (minVal < 0) ? minVal : 0;
        })(), d3.max(data, (d) => {
            return d.metric1;
        })]);

        // spacing for the legend
        var legendSpace = chartWidth / dNest.length;

        console.warn(legendSpace)
        // Add the X Axis
        svg.append("g")
            .attr("class", "x-axis")
            .attr("transform", "translate(0," + chartHeight + ")")
            .call(x1AxisLabel)
            .selectAll('text')
            .style('font-size', fontSize)
            .style('text-anchor', 'end')
            .attr('dx', '-.8em')
            .attr('dy', '-.20em')
            .attr('transform', 'rotate(-60)')

        svg.append('text')
            .attr('x', (chartWidth / 2))
            .attr('y', chartHeight + chartMargin.bottom + 10)
            .style('fill', fontColor)
            .style("text-anchor", "middle")
            .text(chart.x1AxisDisplayName)
            .style('font-size', axisLabelFontSize)

        // Add the Y Axis
        svg.append("g")
            .attr("class", "y-axis")
            .call(y1AxisLabel)
            .style("font-size", fontSize)

        svg.append('text')
            .attr('transform', 'rotate(-90)')
            .attr('y', 0 - chartMargin.left + 15)
            .attr('x', 0 - (chartHeight / 2))
            .attr("dy", ".71em")
            .style("text-anchor", "middle")
            .style('fill', fontColor)
            .style('font-size', axisLabelFontSize)
            .text(chart.y1AxisDisplayName)

        // Loop through each symbol / key
        dNest.forEach(function (d) {
            var lines = contentGroup.append("path")
                .attr("class", "line")
                .style("stroke", function () { // Add the colours dynamically
                    return d.metric1ColorScale = metric1ColorScale(d.key);
                })
                .attr("id", 'tag' + d.key.replace(/\s+/g, '')) // assign ID
                .attr("stroke-width", 2)
                .attr("fill", "none")
                .attr("d", dataline(d.values))
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            console.warn(lines)

            // Add the dots for the tooltip
            /*d3.select(".d3-tip"+divId.id).remove(); // clear tooltip based on class of tip element // appended with divId to make it unique
            var y1tip = tooltip_class()

            y1tip.attr('class', 'd3-tip'+divId.id)
                .html((d) =>{
                    return "Day"+ colonAnnotation+ formatTime(d.dim1_name) + "<br/> Sales" +
                             "(" + d.dim2_name+")"+ colonAnnotation+ numberFormat(d.metric1)
                })

            svg.call(y1tip);*/

            d3.select("tooltip" + divId.id).remove(); // clear tooltip based on class of tip element
            var div = d3.select(divId).append('div').attr('class', 'tooltip')
                .attr('style', 'position: absolute; opacity: 0;')

            contentGroup.selectAll(".dot")
                .data(data)
                .enter()
                .append("circle")
                .attr("r", 5)
                .attr("class","dot")
                .attr("cx", function (d) {
                    return x1Scale(d.dim1_name);
                })
                .attr("cy", function (d) {
                    return y1Scale(d.metric1);
                })
                .style("fill", function (d) {
                    return metric1ColorScale(d.dim2_name)
                })
                .attr("id", 'tag' + d.key.replace(/\s+/g, '')) // assign ID
                .on("mousemove", function (d) {
                    const fontColor = metric1ColorScale(d.dim2_name)
                    console.log(d3.event, d)
                    div.transition()
                        .duration(200)
                        .style("opacity", .9);
                    div.html("Day" + colonAnnotation + formatTime(d.dim1_name) + "<br/> Sales" +
                        "(" + d.dim2_name + ")" + colonAnnotation + numberFormat(d.metric1)
                    )
                        .style("left", (d3.event.layerX) + "px")
                        .style("top", (d3.event.layerY) + "px")
                        .style("color",fontColor);
                })
                .on("mouseout", function () {
                    div.transition().style("opacity", 0)
                })
            //.on("mouseover", y1tip.show)
            //.on("mouseout", y1tip.hide)
            //.on('contextmenu',  contextMenu(downloadData)); //commented due to hardcoding

            // Add the Legend
            var y1legend = svg.selectAll('.legend')
                .data(metric1ColorScale.domain())
                .enter().append('g')
                .attr('class', 'legend')
                .attr("transform", function (d, i) {
                    return "translate(30," + i * 25 + ")";
                });

            y1legend.append('circle')
                .attr('cx', chartWidth + chart.vizSpecific2)
                .attr('cy', chart.vizSpecific1 - 2)
                .attr('r', 5)
                .attr('fill', metric1ColorScale)

            y1legend.append('text')
                .attr('x', chartWidth + chart.vizSpecific2 + 10)
                .attr('y', chart.vizSpecific1)
                .attr('dy', '.1em')
                .style('fill', metric1ColorScale)
                .text((d) => {
                    return d
                })
        });

        // Add zoom functionality
        var zoomBehaviour = d3.zoom()
            .scaleExtent([1, 10])  // Define zoom range
            .on("zoom", zoomed);  // Attach zoom event

// Apply zoom to the SVG
        contentGroup.insert("rect", "circle")
            .attr("width", chartWidth)
            .attr("height", chartHeight)
            .attr("fill", "none")
            .attr("pointer-events", "all")
            .call(zoomBehaviour);

        function zoomed() {
            var zoomState = d3.zoomTransform(this);
            var newXScale = zoomState.rescaleX(x1Scale);
            var newYScale = zoomState.rescaleY(y1Scale);

            // Update the Y axis
            svg.select('.y-axis').call(d3.axisLeft(newYScale).ticks(10).tickFormat(numberFormat));
            svg.select('.x-axis').call(d3.axisBottom(newXScale).tickFormat(formatTime)) .selectAll('text')
                .style('font-size', fontSize)
                .style('text-anchor', 'end')
                .attr('dx', '-.8em')
                .attr('dy', '-.20em')
                .attr('transform', 'rotate(-60)');
            // Bind the correct data to the lines and update their paths with the new y-scale
            contentGroup.selectAll(".line")
                .data(dNest)
                .attr("d", (d) => {
                    let line = d3.line()
                        .x(d => {
                            return newXScale(d.dim1_name)
                        })
                        .y(d => {
                            return newYScale(d.metric1)
                        })
                    console.log("line from zoom function",line)

                    return line(d.values)
                })

            // Update the circles (dots) to move accordingly
            contentGroup.selectAll(".dot")
                .attr("cx", function(d) {
                    return newXScale(d.dim1_name);
                })
                .attr("cy", function(d) {
                    return newYScale(d.metric1);
                });
        }
    // });
}
